import React from 'react';

import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Link, IconButton, Divider } from '@material-ui/core';
import { Twitter, Facebook, LinkedIn, YouTube, GitHub, Language, Mail, HeadsetMic } from '@material-ui/icons';

import * as link from '../../utilities/link-config';

import logo from '../../assets/orange-logo.png';
import berlin from '../../assets/berlin.png';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
        padding: theme.spacing(4),
        paddingBottom: theme.spacing(2),
        backgroundColor: theme.palette.grey[200]
    },
    imageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('xs')]: {
            justifyContent: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start'
        }
    },
    image: {
        maxWidth: 120,
        [theme.breakpoints.up('xs')]: {
            marginTop: theme.spacing(2),
            order: 2

        },
        [theme.breakpoints.up('sm')]: {
            order: 1,
            marginTop: 0
        }
    },
    berlin: {
        maxWidth: 120,
        [theme.breakpoints.up('xs')]: {
            order: 1
        },
        [theme.breakpoints.up('sm')]: {
            order: 2,
            marginTop: theme.spacing(1),
        }
    },
    socialMedia: {
        marginTop: theme.spacing(2),
    },
    icon: {
        color: theme.palette.primary.main
    },
    content: {
        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
        }
    },
    linksWrapper: {
        display: 'flex',
        [theme.breakpoints.up('xs')]: {
            marginTop: theme.spacing(2),
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            marginTop: 0,
            justifyContent: 'flex-start',
            textAlign: 'left'
        },
    },
    header: {
        color: theme.palette.primary.main,
        fontWeight: 700,
        lineHeight: 1,
        fontSize: theme.typography.h6.fontSize,
        marginBottom: theme.spacing(1)
    },
    contactForm: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(0.5),
        [theme.breakpoints.up('xs')]: {
            justifyContent: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start'

        }

    },
    links: {
        display: 'flex',
        flexDirection: 'column'
    },
    section: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('xs')]: {
            marginTop: theme.spacing(1),
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
        }
    },
    imprint: {
        marginTop: theme.spacing(2),
        textAlign: 'center'
    }
}))

export default function Footer(props) {
    const classes = useStyles();

    const Header = (props) => {
        return (
            <Typography className={classes.header} variant="body1">
                {props.text}
            </Typography>
        )
    }

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <div className={classes.imageWrapper}>
                    <img src={logo} className={classes.image} />
                    <img src={berlin} className={classes.berlin} />
                </div>
                <div className={classes.linksWrapper}>
                    {
                        [
                            {
                                header: "nanocosmos",
                                list: [
                                    { link: link.NANOCOSMOS, text: "About Us" },
                                    { link: link.BLOG, text: "Blog" },
                                    { link: link.DOCS, text: "Docs" },
                                    { link: link.TRIAL, text: "Free Trial" },
                                ]
                            },
                            {
                                header: "nanoStream Cloud",
                                list: [
                                    { link: link.INFO, text: "nanoStream Cloud" },
                                    { link: link.WEBCASTER, text: "nanoStream Webcaster" },
                                    { link: link.H5LIVE, text: "nanoStream H5Live Player" },
                                    { link: link.ANALYTICS, text: "nanoStream Analytics" },
                                ]
                            },

                        ].map((link) => (
                            <div key={link.header} className={clsx(classes.section)}>
                                <Header text={link.header} />
                                <div className={classes.links}>
                                    {
                                        link.list.map((item) => (
                                            <Typography color="textSecondary" key={item.text} variant="body1" className={classes.link}>
                                                <Link color="textSecondary" target="blank" href={item.link}>
                                                    {item.text}
                                                </Link>
                                            </Typography>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                    <div className={clsx(classes.section, classes.contact)}>
                        <Header text="Contact Us" />
                        {
                            [
                                { icon: <Mail color="primary" fontSize="default" />, link: link.CONTACT, text: "Contact Form" },
                                { icon: <HeadsetMic color="primary" fontSize="default" />, link: link.SUPPORT, text: "Get Support" },
                            ].map((contact) => (
                                <div key={contact.text} className={classes.contactForm}>
                                    {contact.icon}
                                    <Typography variant="body1">
                                        <Link color="textSecondary" href={contact.link} target="blank" style={{ marginLeft: '8px' }}>
                                            {contact.text}
                                        </Link>
                                    </Typography>
                                </div>

                            ))
                        }
                        <div className={classes.socialMedia}>
                            {
                                [
                                    { icon: <GitHub className={classes.icon} />, link: link.GITHUB },
                                    { icon: <Facebook className={classes.icon} />, link: link.FACEBOOK },
                                    { icon: <LinkedIn className={classes.icon} />, link: link.LINKEDIN },
                                    { icon: <Twitter className={classes.icon} />, link: link.TWITTER },
                                    { icon: <YouTube className={classes.icon} />, link: link.YOUTUBE },
                                ].map((item, index) => (
                                    <IconButton size="small" href={item.link} key={index}>
                                        {item.icon}
                                    </IconButton>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.imprint}>
                <Divider />
                <Typography variant="button" color="textPrimary">
                    &copy; {new Date().getFullYear()} nanocosmos GmbH <Link color="textSecondary" target="blank" href={link.TERMS}>Terms and Conditions</Link>
                </Typography>
            </div>
        </div>
    )
}